import getConfig from 'next/config';

import { isZigzag } from '@common/device-manager';

import { isDomesticShippingUseCookie } from './address_utils';

const config = getConfig().publicRuntimeConfig.config;

interface Purchase {
  total_quantity?: string; // 주문 내 상품 개수(optional)
  total_price?: string; // 주문 총 가격(optional)
  currency?: string; // 주문 가격의 화폐 단위(optional, 기본 값은 KRW). ISO 4217 기준의 3문자 통화코드
  products?: Item[]; // 주문 내 상품 정보(optional)
  tag?: string;
}

interface Item {
  id: string;
  name: string;
  quantity: string;
  price: string;
}

interface Search {
  keyword?: string;
  tag?: string;
}

interface Basic {
  id?: string;
  tag?: string;
}

/**
 * Kakao Pixel Event: Description (https://kakaoad.github.io/kakao-pixel/Documentation.html)
 * PageView: 방문 이벤트 전송
 * completeRegistration: 회원가입 이벤트 전송
 * search: 검색 이벤트 전송
 * viewContent: 콘텐츠 / 상품 조회 이벤트 전송
 * addToCart: 장바구니 추가 이벤트 전송
 * addToWishList: 관심상품 추가 이벤트 전송
 * viewCart: 장바구니 보기 이벤트 전송
 * purchase: 구매 이벤트 전송
 * participation: 잠재고객 이벤트 전송
 * signUp: 서비스신청 이벤트 전송
 */

interface Events {
  pageView: (tag?: string) => void;
  completeRegistration: (tag?: string) => void;
  search: (input?: Search) => void;
  viewContent: (input?: Basic) => void;
  addToCart: (input?: Basic) => void;
  addToWishList: (input?: Basic) => void;
  viewCart: (tag?: string) => void;
  purchase: (input?: Purchase) => void;
  participation: (tag?: string) => void;
  signUp: (tag?: string) => void;
}

declare global {
  interface Window {
    kakaoPixel?: (kakao_pixel_id: string) => Events;
  }
}

export const trackKakaoPixel = (event_name: keyof Events, args?: any) => {
  if (!isZigzag() && config.kakao_pixel_id && window.kakaoPixel !== undefined && isDomesticShippingUseCookie()) {
    window.kakaoPixel(config.kakao_pixel_id)?.[event_name](args);
  }
};
